module.exports = __webpack_public_path__ + "media/images/icons/plus-circle-8240927d92016269848e18ccaa1f78b6.svg";